import Http from '../http'

export const store = (data) => Http.patch('/orders/' + data.id + '/shipping', data, { headers: { Authorization: localStorage.token } })
export const edit = (data) => Http.patch('/orders/' + data.id + '/shipping/' + data.shipping_id, data, { headers: { Authorization: localStorage.token } })
